// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-overlay {
  background-color: rgba(255, 255, 255, 0.75);
  transition: all 0.4s ease;
  transform: scale(0);
  opacity: 0;
  z-index: 101;
}
.loading-overlay.active {
  display: block;
  transform: scale(1);
  opacity: 1;
}
.loading-indicator {
  text-align: center;
}
.loader {
  font-size: 6px;
  position: relative;
  border-top: 0.8em solid rgba(0, 0, 0, 0.1) !important;
  border-right: 0.8em solid rgba(0, 0, 0, 0.1) !important;
  border-bottom: 0.8em solid rgba(0, 0, 0, 0.1) !important;
  border-left: 0.8em solid rgba(84, 73, 241, 0.9);
  transform: translateZ(0);
  animation: loadingCircle 0.7s infinite linear;
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
@keyframes loadingCircle {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
